import {ServiceMaker} from './index'

export const getCategoryList = () => ServiceMaker('category/list', 'GET')

export const vehicleCategory = () => ServiceMaker('category/vehicle', 'POST') 